export default __webpack_public_path__ + "static/media/orientexpress.ca11ddfd.jpeg";